"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _FareLock = _interopRequireDefault(require("../screens/FareLock"));
var _context = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FareLock = _ref => {
  let {
    disableSocialLogin,
    onGoogleLogin,
    onFacebookLogin,
    onAppleLogin,
    onChangeScreen,
    googleError,
    facebookError
  } = _ref;
  const {
    log
  } = (0, _context.useLog)();
  React.useEffect(() => {
    log(_events.FARE_LOCK_SCREEN_SHOWN, {});
  }, [log]);
  const handleIncorrectEmail = () => {
    log(_events.GET_SIMPLE_TOKEN, {});
    onChangeScreen("getSingleBooking");
  };
  const handleEmailLogin = () => {
    log(_events.CONTINUE_WITH_EMAIL, {});
    onChangeScreen("emailLogin");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FareLock.default, {
    disableSocialLogin: disableSocialLogin,
    onAppleLogin: onAppleLogin,
    onEmailLogin: handleEmailLogin,
    onGoogleLogin: onGoogleLogin,
    onFacebookLogin: onFacebookLogin,
    onIncorrectEmail: handleIncorrectEmail,
    googleError: googleError,
    facebookError: facebookError
  });
};
var _default = exports.default = FareLock;